import { cn } from '@/lib/utils';

interface PillConfig {
  bg: string;
  text: string;
  extraClasses?: string;
}

export const createPill = (config: PillConfig) => {
  const Pill = ({ label }: { label: string }) => (
    <span
      className={cn(
        'rounded-full px-2 py-0.5 text-[10px] font-medium',
        config.bg,
        config.text,
        config.extraClasses,
      )}
    >
      {label}
    </span>
  );
  return Pill;
};

export const CurrentPlanPill = createPill({
  bg: 'bg-emerald-500/10',
  text: 'text-emerald-400',
});

export const EndingPlanPill = createPill({
  bg: 'bg-amber-500/10',
  text: 'text-amber-400',
});

export const StartingPlanPill = createPill({
  bg: 'bg-emerald-500/10',
  text: 'text-emerald-400',
});

export const DefaultPaymentPill = createPill({
  bg: 'bg-emerald-500/10',
  text: 'text-emerald-400',
  extraClasses: 'font-mono',
});
